export default "__VITE_ASSET__C57uchnu__"